import './Loader.css';

/**
 * Reusable Loader Component
 *
 * @param {Object} props - Component props
 * @param {string} props.type - Type of loader: 'fullscreen', 'inline', 'overlay' (default: 'inline')
 * @param {string} props.size - Size of loader: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} props.message - Optional loading message to display
 * @param {string} props.color - Optional color override for the loader
 *
 * Usage examples:
 * <Loader /> // Simple inline loader
 * <Loader type="fullscreen" message="Loading assets..." />
 * <Loader type="inline" size="small" />
 * <Loader type="overlay" message="Please wait..." />
 */
const Loader = ({
  type = 'inline',
  size = 'medium',
  message = 'Loading...',
  color
}) => {
  const loaderClassName = `loader-container loader-${type} loader-${size}`;

  return (
    <div className={loaderClassName}>
      <div className="loader-content">
        <div className="loader-spinner" style={color ? { borderTopColor: color } : {}}>
          <div className="loader-spinner-inner"></div>
        </div>
        {message && <p className="loader-message">{message}</p>}
      </div>
    </div>
  );
};

export default Loader;
